/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * ContractVolumeInformation Component
 *
 * @param contractVolumeInformation
 * @param newContractVolumeInformation
 * @returns {Element}
 * @constructor
 */
export function ContractVolumeInformation({ contractVolumeInformation, newContractVolumeInformation }) {
  const { t } = useTranslation();
  if (!contractVolumeInformation) {
    return null;
  }
  if (newContractVolumeInformation && newContractVolumeInformation.totalContractVolume) {
    return (
      <>
        <span>
          {t('totalContractVolume')}
          {': '}
        </span>

        <span>
          {parseFloat(newContractVolumeInformation?.totalContractVolume).toFixed(2)}
          €
        </span>
      </>
    );
  }
  return (
    <>
      <span>
        {t('totalContractVolume')}
        {': '}
      </span>
      <span>
        {parseFloat(contractVolumeInformation?.totalContractVolume).toFixed(2)}
        €
      </span>
    </>
  );
}

ContractVolumeInformation.propTypes = {
  contractVolumeInformation: PropTypes.shape({
    totalContractVolume: PropTypes.number,
  }),
  newContractVolumeInformation: PropTypes.shape({
    totalContractVolume: PropTypes.number,
  }),
};

ContractVolumeInformation.defaultProps = {
  contractVolumeInformation: null,
  newContractVolumeInformation: null,
};
